import { Icon, type SymbolCodepoints } from '@uag/react-core';
import { clsx } from 'clsx';
import { type ComponentProps } from 'react';

export const LinkButton = ({
    label,
    icon,
    className,
    children,
    ...props
}: { label?: string; icon?: SymbolCodepoints; className?: string } & ComponentProps<'button'>) => {
    return (
        <button
            className={clsx(
                'link cursor-pointer',
                // mr-5 to offset the icon which is positioned absolute
                icon && 'mr-5',
                className,
            )}
            type="button"
            {...props}
        >
            {label}
            {children}
            {icon && <Icon className="link-decoration" icon={icon} />}
        </button>
    );
};
